import {useQuery} from "@tanstack/react-query";
import {DeadlineSearchParamType} from "../interface";
import {readDeadlineList} from "../../../../../api/order/DeadlineApi";
import {deadlineListMapInit} from "../state";

type Props = {
    param: DeadlineSearchParamType;
};

export const useReadDeadlineList = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readDeadlineList", param],
        queryFn: async () => await readDeadlineList(param),
        select: (res) => res?.data.result ?? deadlineListMapInit,
    });

    return {data};
};
